export default "__VITE_ASSET__qtgOdLls__"